<template>
  <div class="bordered-layout">
    <!-- FILE FILTER -->
    <b-card
      no-body
      class="mb-1"
    >
      <b-card-body>
        <div class="row">
          <div class="col-12 col-md-3">
            <b-form-group
              label="Từ khóa"
              label-for="searchInput"
            >
              <b-input-group>
                <b-form-input
                  v-model="localSearchQuery"
                  class="d-inline-block"
                  placeholder="Tên,file"
                  @keyup.enter="updateSearchQuery"
                />
                <b-input-group-append>
                  <b-button
                    variant="primary"
                    @click="searchFiles"
                  >
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group
              label="Từ ngày"
              label-for="startDate"
            >
              <div class="input-group">
                <flat-pickr
                  ref="startDateRef"
                  v-model="startDate"
                  class="form-control"
                  :config="configDate"
                  placeholder="Từ ngày"
                  @on-change="searchFiles"
                  @on-close="searchFiles"
                />
                <div class="input-group-append">
                  <button
                    v-if="!startDate"
                    class="input-group-text"
                    type="button"
                    @click.prevent="openStartDate"
                  >
                    <feather-icon icon="CalendarIcon" />
                  </button>
                  <button
                    v-if="startDate"
                    class="input-group-text"
                    type="button"
                    @click.prevent="clearStartDate"
                  >
                    <feather-icon icon="XIcon" />
                  </button>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group
              label="Đến ngày"
              label-for="endDate"
            >
              <div class="input-group">
                <flat-pickr
                  ref="endDateRef"
                  v-model="endDate"
                  class="form-control"
                  :config="configDate"
                  placeholder="Đến ngày"
                  @on-change="searchFiles"
                  @on-close="searchFiles"
                />
                <div class="input-group-append">
                  <button
                    v-if="!endDate"
                    class="input-group-text"
                    type="button"
                    @click.prevent="openEndDate"
                  >
                    <feather-icon icon="CalendarIcon" />
                  </button>
                  <button
                    v-if="endDate"
                    class="input-group-text"
                    type="button"
                    @click.prevent="clearEndDate"
                  >
                    <feather-icon icon="XIcon" />
                  </button>
                </div>
              </div>
            </b-form-group>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- table -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <vue-good-table
          ref="tableGood"
          :columns="columns"
          :rows="itemsData"
          :rtl="direction"
          :search-options="{
            enabled: false,
            externalQuery: searchQuery
          }"
          :select-options="{
            enabled: true,
            selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'dòng được chọn',
            clearSelectionText: 'xóa',
            disableSelectInfo: false, // disable the select info panel on top
            selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength
          }"
          :sort-options="{
            enabled: false,
          }"
          @on-selected-rows-change="onSelectedRowChange"
          @on-page-change="onPageChange"
        >
          <template slot="selected-row-actions">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="addSelectedFileToEditor"
            >
              <feather-icon icon="PlusIcon" /> Chèn các file đã chọn
            </b-button>
          </template>
          <template
            slot="table-row"
            slot-scope="props"
          >
            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'file'"
              class="text-nowrap"
            >
              <span class="text-wrap">{{ props.row.file }}</span>
            </span>
            <!-- Column: Created At -->
            <span v-else-if="props.column.field === 'created_at'">
              {{ convertDate(props.row.created_at) }}
            </span>
            <!-- Column: Action -->
            <span v-else-if="props.column.field === 'action'">
              <b-button
                size="sm"
                class=""
                variant="outline-primary"
                @click="addFileToEditor(props.row)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <div class="d-flex justify-content-between flex-wrap p-1">
              <div class="d-flex align-items-center">
                <span class="text-nowrap ">
                  Hiển thị 1 đến
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['10', '20', '30', '50']"
                  class="mx-1"
                  @input="(value) => props.perPageChanged({ currentPerPage: value })"
                />
                <span class="text-nowrap"> của {{ props.total }} mục </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  prev-class="prev-item"
                  next-class="next-item"
                  class="m-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay, BCard, BCardBody, BButton, BFormInput, BInputGroup, BInputGroupAppend,
  BFormGroup, BFormSelect, BPagination,

} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { insertFileToEditor } from '@/libs/initTinymce';
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import { ref, watch } from '@vue/composition-api';
import { formatDate } from '@/libs/helper';
import useFileManager from '../useFileManager';

export default {
  components: {
    VueGoodTable,
    BOverlay,
    BCard,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BInputGroup,
    BCardBody,
    BInputGroupAppend,
    flatPickr,
  },
  data() {
    return {
      localSearchQuery: '',
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: '#',
          field: 'id',
        },
        {
          label: 'File',
          field: 'file',
        },
        {
          label: 'Thời gian',
          field: 'created_at',
        },
        {
          label: 'Chèn',
          field: 'action',
        },
      ],
      selectedRows: [],
      searchTerm: '',
    }
  },
  setup() {
    const searchQuery = ref('');
    const startDate = ref('');
    const endDate = ref('');
    const itemsData = ref([]);
    const {
      loading,
      autoFetchFiles,
      configDate,
    } = useFileManager();

    const fetchFilesDalet = () => {
      loading.value = true;
      store
        .dispatch('files/fetchFilesDalet', {
          keyword: searchQuery.value,
          start_date: startDate.value,
          end_date: endDate.value,
        })
        .then((res) => {
          loading.value = false;
          if (res.status === 200) {
            if (res.data.code === 200) {
              // console.log('res.data', res.data);
              itemsData.value = Array.isArray(res.data.data) ? res.data.data : [];
            }
          }
        });
    };

    watch([searchQuery, startDate, endDate], () => {
      fetchFilesDalet();
    });

    return {
      loading,
      itemsData,
      fetchFilesDalet,
      autoFetchFiles,
      searchQuery,
      startDate,
      endDate,
      configDate,
    }
  },
  computed: {

    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  // watch: {
  //   '$store.state.files.show_all_category': function () {
  //     this.fetchFilesDalet();
  //   },
  // },
  mounted() {
    if (this.autoFetchFiles) {
      this.fetchFilesDalet();
    }
  },
  methods: {
    updateSearchQuery() {
      this.searchQuery = this.localSearchQuery;
      this.searchFiles();
    },
    onPageChange(params) {
      this.currentPage = params.currentPage;
    },
    clearStartDate() {
      this.startDate = '';
    },
    clearEndDate() {
      this.endDate = '';
    },
    openStartDate() {
      this.$refs.startDateRef.$el.focus();
    },
    openEndDate() {
      this.$refs.endDateRef.$el.focus();
    },
    searchFiles() {
      this.fetchFilesDalet();
    },
    addFileToEditor(item) {
      this.$store.dispatch('files/setState', {
        show_file_manager: false,
        auto_fetch_files: false,
        // file_from_editor: false,
        file_info: item,
      });
      insertFileToEditor(item);
    },
    onSelectedRowChange() {
      this.selectedRows = this.$refs.tableGood.selectedRows;
    },
    addSelectedFileToEditor() {
      if (this.selectedRows.length) {
        this.selectedRows.forEach(file => {
          this.addFileToEditor(file);
        });
      }
    },
    convertDate(date) {
      return formatDate(date)
    },
  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
